var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFilmroom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.033,
    height: 26.854,
    viewBox: "0 0 28.033 26.854",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "theater-svgrepo-com",
    transform: "translate(-20.848 -4.624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M48.261,0H21.468a.62.62,0,0,0-.62.62V15.777a.62.62,0,0,0,.62.62H48.261a.62.62,0,0,0,.62-.62V.62A.62.62,0,0,0,48.261,0Zm-.989,16.4H22.56V2.17H47.272V16.4Z",
    transform: "translate(0 4.624)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M70.844,221.488a.564.564,0,0,1,.153,0,.62.62,0,0,0,.62-.62v-2.756a3.146,3.146,0,0,0-6.292,0v2.756a.62.62,0,0,0,.62.62Zm-2.373-5.282a1.909,1.909,0,0,1,1.907,1.907v2.136H66.564v-2.136A1.909,1.909,0,0,1,68.471,216.206Z",
    transform: "translate(-40.802 -197.207)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M158.869,221.488a.565.565,0,0,1,.153,0,.62.62,0,0,0,.62-.62v-2.756a3.146,3.146,0,0,0-6.292,0v2.756a.62.62,0,0,0,.62.62Zm-2.373-5.282a1.909,1.909,0,0,1,1.907,1.907v2.136h-3.813v-2.136A1.909,1.909,0,0,1,156.5,216.206Z",
    transform: "translate(-121.555 -197.207)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M246.894,221.488a.565.565,0,0,1,.153,0,.62.62,0,0,0,.62-.62v-2.756a3.146,3.146,0,0,0-6.292,0v2.756a.62.62,0,0,0,.62.62Zm-2.373-5.282a1.909,1.909,0,0,1,1.907,1.907v2.136h-3.813v-2.136A1.909,1.909,0,0,1,244.521,216.206Z",
    transform: "translate(-202.307 -197.207)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M25.847,302.065a3.149,3.149,0,0,0-3.146,3.146v2.756a.62.62,0,0,0,.62.62h4.9a.609.609,0,0,0,.077-.005.634.634,0,0,0,.077.005.62.62,0,0,0,.62-.62v-2.756A3.149,3.149,0,0,0,25.847,302.065Zm0,1.239a1.909,1.909,0,0,1,1.907,1.907v2.136H23.94v-2.136A1.909,1.909,0,0,1,25.847,303.3Z",
    transform: "translate(-1.7 -277.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M112.946,302.065a3.149,3.149,0,0,0-3.146,3.146v2.756a.62.62,0,0,0,.62.62h4.9a.611.611,0,0,0,.077-.005.633.633,0,0,0,.077.005.62.62,0,0,0,.62-.62v-2.756A3.15,3.15,0,0,0,112.946,302.065Zm0,1.239a1.909,1.909,0,0,1,1.907,1.907v2.136h-3.813v-2.136A1.909,1.909,0,0,1,112.946,303.3Z",
    transform: "translate(-81.603 -277.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M200.044,302.065a3.15,3.15,0,0,0-3.146,3.146v2.756a.62.62,0,0,0,.62.62h4.9a.611.611,0,0,0,.077-.005.633.633,0,0,0,.077.005.62.62,0,0,0,.62-.62v-2.756A3.15,3.15,0,0,0,200.044,302.065Zm0,1.239a1.909,1.909,0,0,1,1.907,1.907v2.136h-3.813v-2.136A1.909,1.909,0,0,1,200.044,303.3Z",
    transform: "translate(-161.505 -277.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M287.144,302.065A3.149,3.149,0,0,0,284,305.211v2.756a.62.62,0,0,0,.62.62h4.9a.612.612,0,0,0,.077-.005.632.632,0,0,0,.077.005.62.62,0,0,0,.62-.62v-2.756A3.15,3.15,0,0,0,287.144,302.065Zm0,1.239a1.909,1.909,0,0,1,1.907,1.907v2.136h-3.813v-2.136A1.909,1.909,0,0,1,287.144,303.3Z",
    transform: "translate(-241.409 -277.109)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilmroom);
export default __webpack_public_path__ + "static/media/icon-filmroom.d20f2dab17823c0f005f9777d6ac396b.svg";
export { ForwardRef as ReactComponent };